module.exports = __webpack_public_path__ + "img/public/siteImages/defaultPic.jpg?5a2de035";